export type Locale = 'en' | 'pt' | 'es' | 'fr'

export function formatLocalLink(path: string, locale: Locale): string {
  // Ensure path starts with a slash
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  return `/${locale}${normalizedPath}`
}

export function formatMainLink(path: string, locale?: Locale): string {
  const localeMap: Record<string, string> = {
    en: 'en-GB',
    pt: 'pt-PT',
    es: 'es',
    fr: 'fr',
  }

  const mappedLocale = locale ? localeMap[locale.toLowerCase()] || 'en' : ''
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `https://lisbonquake.com/${mappedLocale}${normalizedPath}`
}
